import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { camelCase_to_Sentence, toTitleCase } from '@iotv/core-services';
import { PayloadTypes } from '@iotv/payload-definition-core';
import { TableCell, TableRow } from '@mui/material';
import { useState } from 'react';
import { DeviceControlDAO } from '../../../../../data/DeviceControlDAO';
import { ActionIcons } from '../../../../../Iconography';
import { ConfirmButton } from '../../../../common/ConfirmButton';
import { Arbitrator } from './Arbitrator';
export const ControlRow = (props) => {
    const { name, attribute, user, device } = props;
    const [sending, setSending] = useState(false);
    /** the measure code / message header should never be user-configurable, as it is device-dependent and we already know the device by now */
    if (attribute instanceof PayloadTypes.PayloadAttributeMessageType)
        return _jsx(_Fragment, {});
    const readableName = toTitleCase(camelCase_to_Sentence(name));
    const { elements, payload, valid } = Arbitrator({ ...props, disable: sending });
    const sendButton = (_jsx(ConfirmButton, { variant: "outlined", confirmMessage: "Confirm?", onConfirm: async () => {
            setSending(true);
            if (device && user)
                await DeviceControlDAO.device.control.command.send({ desiredPayload: payload, devices: [device], requestInitiator: user });
            setSending(false);
        }, disabled: !valid, loading: sending, endIcon: _jsx(ActionIcons.Send, {}), children: "Send" }));
    return (_jsxs(TableRow, { children: [_jsx(TableCell, { children: readableName }), _jsx(TableCell, { children: elements }), _jsx(TableCell, { children: sendButton })] }));
};
